/**
 * Mood (D6 from PRODUCT_PLAN): 1–5 scale + quick tags.
 * No dedicated table: entry attributes. The UI translates the keys.
 */

export const MOOD_MIN = 1;
export const MOOD_MAX = 5;
export const MOOD_VALUES = [1, 2, 3, 4, 5] as const;
export type MoodValue = (typeof MOOD_VALUES)[number];

export const MOOD_EMOJIS: Record<MoodValue, string> = {
  1: "😞",
  2: "😕",
  3: "😐",
  4: "🙂",
  5: "😄",
};

/** Suggested mood tag vocabulary (i18n keys; free input allowed). */
export const SUGGESTED_MOOD_TAGS = [
  "calm",
  "grateful",
  "happy",
  "energetic",
  "tired",
  "stressed",
  "anxious",
  "sad",
] as const;

export function isMoodValue(value: number | null | undefined): value is MoodValue {
  return typeof value === "number" && value >= MOOD_MIN && value <= MOOD_MAX;
}

/** Parses `journal_entry.mood_tags` (JSON array), tolerating malformed input. */
export function parseMoodTags(raw: string | null | undefined): string[] {
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((t): t is string => typeof t === "string" && t.length > 0);
  } catch {
    return [];
  }
}
